// dev uses vite proxy
const API_BASE = (import.meta.env.DEV ? '' : (import.meta.env.VITE_API_URL ?? '')).replace(/\/$/, '');

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

let _orgSlug: string | null = null;

export function setOrgSlug(slug: string | null) {
  _orgSlug = slug;
}

export function getOrgSlug(): string | null {
  return _orgSlug;
}

export function gemCandidateUrl(gemAtsId: string | null, gemCrmId: string | null): string | null {
  const id = gemAtsId || gemCrmId;

  if (!id) return null;
  return `https://www.gem.com/candidate/${btoa(`Person:${id}`)}`;
}

export function platformCandidateUrl(platformUserId: number | null): string | null {
  if (!platformUserId) return null;
  return `https://app.breakline.org/hq/participants/${platformUserId}`;
}
